/**
 * Tipos compartidos del cliente API.
 *
 * Las APIs FastAPI usan un envelope uniforme (ver migration/05_API_CONTRACTS.md):
 *   { "data": T | null, "error": {code,message} | null, "meta": {...} }
 */

export interface ApiErrorBody {
  code: string;
  message: string;
}

export interface ApiMeta {
  total?: number;
  page?: number;
  limit?: number;
  [key: string]: unknown;
}

export interface Envelope<T> {
  data: T | null;
  error: ApiErrorBody | null;
  meta?: ApiMeta;
}

/**
 * Error tipado del cliente API. Conserva `code` + `status` para que los
 * consumers (TanStack Query, mutations) decidan retry / redirect / mensaje.
 *
 * Se mantiene la forma `{ status, code }` que los hooks legacy adjuntaban a
 * los Error de Supabase, para minimizar el diff en la UI.
 */
export class ApiError extends Error {
  public readonly code: string;
  public readonly status: number;
  public readonly retryable: boolean;
  /**
   * `meta` del envelope de error, cuando el server lo adjunta. Algunos errores
   * informativos llevan contexto útil que no es un fallo duro — p. ej. el 409
   * de la lista de espera trae `meta.position` para que la pantalla muestre la
   * posición sin una segunda llamada.
   */
  public readonly meta?: ApiMeta;

  constructor(
    code: string,
    message: string,
    status: number,
    retryable = false,
    meta?: ApiMeta,
  ) {
    super(message);
    this.name = 'ApiError';
    this.code = code;
    this.status = status;
    this.retryable = retryable;
    this.meta = meta;
  }
}

export interface TokenPair {
  access_token: string;
  refresh_token: string;
  token_type?: string;
  expires_in?: number;
}
